import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelDictionaryInfo', request)
}

export {get}
